// extracted by mini-css-extract-plugin
export default {"videos":"admin-media_videos__EOJKc","video":"admin-media_video__svLdL","video__title":"admin-media_video__title__j6ftS","video__buttons":"admin-media_video__buttons__Cw-6x"};